<template>
  <v-container class="p-insure px-0">
    <v-layout>
      <Stepper :value="1" class="stepper"></Stepper>
    </v-layout>
    <v-layout row class="mt-2">
      <v-flex grow>
        <!-- 投保 -->
        <CSection title="投保" class="insure-card">
          <h3>泰康在线企业团体保险</h3>
          <v-form ref="form" lazy-validation class="form">
            <!-- 企业信息 -->
            <section class="form-section">
              <p class="mb-4">企业及联系人信息</p>
              <div class="form-item">
                <label>企业名称</label>
                <v-text-field v-model="form.companyName" :solo="solo" :rules="rules.companyName"></v-text-field>
              </div>
              <div class="form-item form-item-left">
                <label>是否买过此类产品</label>
                <v-checkbox
                  v-model="form.isBuy"
                  label="选中为是"
                  class="isBuy"
                >选中为是</v-checkbox>
              </div>
              <v-layout>
                <v-flex class="form-item">
                  <label>统一社会信用代码</label>
                   <v-text-field
                    placeholder="请输入统一社会信用代码"
                    v-model="form.companyCardNo"
                    :solo="solo"
                    :rules="rules.companyCardNo"
                    label
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex class="form-item">
                  <label>行业类别</label>
                  <v-select
                    v-model="form.industryCategory"
                    :items="categories"
                    item-text="name"
                    item-value="code"
                    :rules="rules.categories"
                    :solo="solo"
                    label
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex class="form-item form-item-left">
                  <label>联系人姓名</label>
                  <v-text-field v-model="form.contactName" :solo="solo" :rules="rules.contactName"></v-text-field>
                </v-flex>
                <v-flex class="form-item">
                  <label>联系人手机号</label>
                  <v-text-field
                    v-model="form.contactPhoneNumber"
                    :solo="solo"
                    :rules="rules.contactPhoneNumber"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <div class="form-item">
                <label>联系邮箱</label>
                <v-text-field v-model="form.contactEmail" :solo="solo" :rules="rules.contactEmail" placeholder="请输入投保人邮箱"></v-text-field>
              </div>
              <div class="form-item">
                <label>联系地址</label>
                <v-distpicker @selected="onSelected" style="margin-bottom:10px;"></v-distpicker>
              </div>
              <div class="form-item">
                <label></label>
                <v-text-field v-model="form.contactDetailAddress" :solo="solo" :rules="rules.address" placeholder="请填写详细地址，精确到门牌号"></v-text-field>
              </div>
            </section>
            <hr class="line">
            <!-- 投保信息 -->
            <section class="form-section">
              <p class="mb-4">投保信息</p>
              <v-layout>
                <v-flex class="form-item form-item-left">
                  <label>生效日期</label>
                  <v-menu
                    ref="dateMenu"
                    v-model="effectBeginDateMenuVisible"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      class="date-input"
                      v-model="form.effectBeginDate"
                      :solo="solo"
                      :rules="rules.effectBeginDate"
                      append-icon="calendar_today"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      v-model="form.effectBeginDate"
                      :header-date-format="date=>date"
                      :min="minEffectBeginDate"
                      no-title
                      @input="effectBeginDateMenuVisible = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex class="form-item">
                  <label>保障期限</label>
                  <v-text-field
                      class="date-input"
                      v-model="form.effectDuration"
                      :solo="solo"
                      readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="form-item-btn-mb">
                <v-flex class="form-item form-item-left">
                  <label>投保员工</label>
                  <div class="form-item-btn-wrap">
                    <v-btn
                      class="form-item-btn"
                      color="primary"
                      block
                      @click="employeeManageVisible = true"
                    >{{ employees.length === 0?"填写员工信息":"修改员工信息" }}</v-btn>
                  </div>
                </v-flex>
                <v-flex class="form-item">
                  <v-layout
                    v-show="employees.length > 0"
                    align-center
                    fill-height
                  >员工总数：{{ employees.length }}</v-layout>
                </v-flex>
              </v-layout>
            </section>
            <hr class="line">
            <!-- 保障方案 -->
            <section class="plan-section">
              <p class="mb-4">保障方案</p>
              <InsurancePlanTable
                v-model="employees"
                :employees="employees"
                @update="planList"
                @price="getAmount"
              ></InsurancePlanTable>
            </section>
          </v-form>
        </CSection>
      </v-flex>
      <v-flex shrink class="right-section">
        <div v-pin="{padding: {top: 136}}" class="pay-card block">
          <div>
            总保费
            <span class="display-1 primary-text">￥{{ form.amount.toFixed(2) }}</span>
          </div>
          <hr class="line">
          <v-layout>
            <v-flex shrink>
              <v-checkbox v-model="form.agree" class="checkbox" label></v-checkbox>
            </v-flex>
            <v-flex>
              我已仔细阅读且确认《
              <a class="primary-text" @click="healthVisible = true">健康告知</a>》的各项全部为否，并接受投保须知及以下条款和告知《
              <a class="primary-text" @click="noticeVisible=true">投保须知及声明</a>》《
              <a class="primary-text" @click="tkVisible = true" :code="1074">保险条款</a>》
            </v-flex>
          </v-layout>
          <v-btn
            class="pay-btn"
            :disabled="!form.agree"
            :loading="loading"
            color="primary"
            block
            @click="onPay"
          >去支付</v-btn>
        </div>
      </v-flex>
    </v-layout>

    <EmployeeManage v-model="employees" :visible.sync="employeeManageVisible"></EmployeeManage>
    <Notice v-model="noticeVisible"></Notice>
    <TKDialog v-model="tkVisible" code="1074"></TKDialog>
    <Health v-model="healthVisible"></Health>
  </v-container>
</template>

<script>
import Stepper from "./components/Stepper";
import InsurancePlanTable from "@/components/Order/TKInsuranceTable";
import EmployeeManage from "@/components/Order/AddEmployee";
import Notice from "./components/TKNotice";
import Health from "./components/TKHealth";
import TKDialog from "./components/TKDialog";

import validate from "@/assets/js/validate";
export default {
  components: {
    Stepper,
    InsurancePlanTable,
    EmployeeManage,
    Notice,
    Health,
    TKDialog
  },
  props: {
    code: String
  },
  data() {
    return {
      distId: '',
      solo: true,
      // effectDurationList: [
      //   { text: "1年", value: 12 },
      //   { text: "11个月", value: 11 },
      //   { text: "10个月", value: 10 },
      //   { text: "9个月", value: 9 },
      //   { text: "8个月", value: 8 },
      //   { text: "7个月", value: 7 },
      //   { text: "6个月", value: 6 },
      //   { text: "5个月", value: 5 },
      //   { text: "4个月", value: 4 },
      //   { text: "3个月", value: 3 },
      //   { text: "2个月", value: 2 },
      //   { text: "1个月", value: 1 }
      // ],
      formValid: true,
      form: {
        companyName: "",
        companyCardType: 4,
        isBuy:false,
        companyCardNo: "",
        contactName: "",
        contactPhoneNumber: "",
        contactEmail: "",
        // 生效日期
        effectBeginDate: "",
        // 保障期限
        effectDuration: '1年',
        // 产品方案，现在只有方案D了
        productPlanId: 4,
        agree: false,
        amount: 0,
        contactDetailAddress:"",
        industryCategory:"",
        contactProvinceCode:"",
        contactCityCode:"",
        contactDistrictCode:""
      },
      rules: {
        companyName: [v => !!v || "请输入企业名称"],
        companyCardNo: [
          v => !!v || "请输入对应的证件号"
        ],
        contactName: [
          v => {
            if (!v) {
              return "请输入联系人姓名";
            }
            if (!validate.isChineseName(v)) {
              return "请输入联系人中文姓名";
            }
            return true;
          }
        ],
        contactPhoneNumber: [
          v => {
            if (!v) {
              return "请输入投保人手机号";
            }
            if (!validate.isMobilePhone(v)) {
              return "请输入正确的投保人手机号";
            }
            return true;
          }
        ],
        contactEmail: [
          v => {
            if (!v) {
              return "请输入联系邮箱";
            }
            if (!validate.isEmail(v)) {
              return "请输入正确的联系邮箱";
            }
            return true;
          }
        ],
        effectBeginDate: [v => !!v || "请选择生效日期"],
        address:[v=> !!v || "请输入详细地址"],
        categories:[v=>!!v||"请选择行业类别"],
        city:[v=>{
          return v
        }]
      },
      // 生效日期选择菜单是否可见
      effectBeginDateMenuVisible: false,
      // 最小生效日期 T+3
      minEffectBeginDate: "",
      // 控制营业执照样例显示
      noticeVisible: false,
      tkVisible: false,
      healthVisible: false,
      // 控制员工管理显示
      employeeManageVisible: false,
      employees: [],
      //保障方案列表,由 Plan 组件实时传递
      planLists: [],
      loading: false
    };
  },
  computed: {
    user() {
      return this.$store.state.user.userInfo;
    },
    categories() {
      let arr = [];
      this.$store.state.insure.tkcategories.map(item=>{
        arr.push(item.children);
      });
      return arr.flat();
    }
  },
  created() {
    this.$store.dispatch("getUserInfo");
    this.form.effectBeginDate = this.minEffectBeginDate = this.$miment()
      .add(1, "DD")
      .format("YYYY-MM-DD");
    // if (process.env.NODE_ENV === "development") {
    //   // 测试信息
    //   this.form = {
    //     companyName: "德玛西亚",
    //     companyCardType: 4,
    //     companyCardNo: "91120103MA06J25628",
    //     contactName: "盖伦",
    //     contactPhoneNumber: "18088888888",
    //     contactEmail: "xiaoliang.li@chinatalentgroup.com",
    //     // 生效日期
    //     effectBeginDate: this.minEffectBeginDate,
    //     // 保障期限
    //     effectDuration: '1年',
    //     // 产品方案，现在只有方案D了
    //     productPlanId: 4,
    //     agree: false,
    //     amount: 0,
    //     contactDetailAddress:"积水潭2号"
    //   };
    //   this.employees = [
    //     {
    //       insuredName: "包婷珊",
    //       relationWithMain:"01",
    //       identifyNumber: "513436200005306058",
    //       mobilephone: "13488805128",
    //       identifyType:1,
    //       mainIdentifyNumber:"",
    //       healthStatus:true,
    //       hasSocialInsurance:true,
    //       occupation: {
    //         code: "00103002",
    //         name: "企业单位职员（内勤",
    //         level: 1
    //       },
    //       plan:{
    //         id: 1,
    //         name: "方案一",
    //         ipIds: ["1"],
    //         quotaPlanCodes:["1305A01601","1305A01615","1305A01626"]
    //       }
    //     },
    //     {
    //       insuredName: "储庆妹",
    //       relationWithMain:"10",
    //       identifyNumber: "51343620000530647X",
    //       mobilephone: "13488805128",
    //       identifyType:1,
    //       mainIdentifyNumber:"513436200005306058",
    //       healthStatus:true,
    //       hasSocialInsurance:false,
    //       occupation: {
    //         code: "00104003",
    //         name: "民间组织和社会团体职员（外勤）",
    //         level: 2
    //       },
    //       plan:{
    //         id: "2",
    //         name: "方案一+重疾",
    //         ipIds: ["1","7"],
    //         quotaPlanCodes:["1305A01602","1305A01616","1305A01628"]
    //       }
    //     },
    //     {
    //       insuredName: "蔡聪",
    //       relationWithMain:"01",
    //       identifyNumber: "110101197303074437",
    //       mobilephone: "13488805128",
    //       identifyType:1,
    //       mainIdentifyNumber:"",
    //       healthStatus:true,
    //       hasSocialInsurance:true,
    //       occupation: {
    //         code: "00202002",
    //         name: "土壤肥料技术人员",
    //         level: 2
    //       },
    //       plan:{
    //         id: "1",
    //         name: "方案一",
    //         ipIds: ["1"],
    //         quotaPlanCodes:["1305A01601","1305A01615","1305A01626"]
    //       }
    //     }
    //   ];
    // }
  },
  methods: {
    onSelected(data) {
      console.log(data);
      this.form.contactProvinceCode = data.province.code;
      this.form.contactCityCode = data.city.code;
      this.form.contactDistrictCode = data.area.code;
    },
    onPay() {
      if (this.$refs.form.validate()) {
        if (this.employees.length < 3) {
          this.$message.error("员工人数至少需要3人，请修改后重新提交");
          return false;
        }
        if (!this.form.contactProvinceCode) {
          this.$message.error("请选择省市区");
          return false;
        }
        this.loading = true;
        const entity = this.transformToEntity();
        console.log(entity);
        this.$axios
          .post("/app/api/tk/submitPolicy", entity)
          .then(res => {
            console.log(res);
            const orderCode = res.data.orderCode;
            this.$router.push({ name: "tkpay", params: { orderCode } });
            this.loading = false;
          })
          .catch(err => {
            this.$message.error(err.message);
            this.loading = false;
          });
      }
    },
    transformToEntity() {
      return {
        userId:this.user&& this.user.id,
        channelId:this.user&&this.user.channelId,
        platformId:1,
        productId:1074,
        startDate: this.form.effectBeginDate,
        insurancePeriod: 1,
        insurancePeriodUnit: 3,
        amount: this.form.amount,
        applicant:{
          applicantName: this.form.companyName,
          transferFlag:this.form.isBuy?0:1,
          identifyType:4,
          identifyNumber:this.form.companyCardNo,
          contactEmail:this.form.contactEmail,
          contactName:this.form.contactName,
          contactMobilePhone:this.form.contactPhoneNumber,
          contactProvinceCode:this.form.contactProvinceCode,
          contactCityCode:this.form.contactCityCode,
          contactDistrictCode:this.form.contactDistrictCode,
          contactDetailAddress:this.form.contactDetailAddress,
          industryCategory:this.form.industryCategory
        },
        planList: this.planLists,
        healthNotice: {
          item1:this.form.agree ? 1 : 2,
          item2:this.form.agree ? 1 : 2,
          item3:this.form.agree ? 1 : 2
        }
      };
    },
    planList(data){
      console.log(data);
      this.planLists = data;
    },
    getAmount(data){
      console.log(data);
      this.form.amount = data;
    }
  },
  mounted() {
    this.$store.dispatch("getTKCategories");
  }
};
</script>


<style lang="scss">
$form-item-left-width: 284px;
$form-item-label-width: 84px;
$label-margin-right: 20px;
$input-width: $form-item-left-width - $form-item-label-width -
  $label-margin-right;
.p-insure {
  .insure-card {
    .form-section {
      padding: 30px 137px 12px 0;
    }
    .plan-section {
      padding: 40px 0;
      .form-item {
        width: 240px !important;
        .plan-section-label {
          width: 56px;
        }
      }
    }
    .form {
      .form-item {
        label {
          width: $form-item-label-width;
          text-align: right;
        }
      }
      .form-item-left {
        width: $form-item-left-width;
        flex-grow: 0;
        .date-input {
          width: $input-width;
        }
      }
      .form-item-btn-mb {
        margin-bottom: 28px;
      }
      .form-item-btn-wrap {
        width: $input-width;
        .v-btn {
          margin: 0;
        }
      }
    }
  }
  .right-section {
    width: 330px;
    margin-left: 20px;
    .pay-card {
      margin: 0;
      width: 330px;
      padding: 50px 25px;
      font-size: 14px;
      .line {
        margin: 20px 0;
      }
      .checkbox {
        margin-top: -4px;
      }
      .pay-btn {
        margin-top: 30px;
        height: 50px;
      }
    }
  }
  .isBuy label{
    margin-top: 0 !important;
  }
  .long {
    width: 250px;
  }
}
</style>
